<template>
  <div class="productcenter-page">
    <header-cmp></header-cmp>

    <!-- banner图 开始-->
    <section class="page-part banner banner_productcenter"></section>
    <!-- banner图 结束-->

    <section class="page-part client huozhu" id="huozhu">
      <div class="page-inner">
        <img src="../assets/images/page_productcenter/huozhu.png" alt="货主端">
        <section class="img-desc">
          <h3 class="page-title">货主端</h3>
          <span class="page-desc">享运货主版APP是一款大宗商品发货APP软件（运输类型包含钢材、熟料颗粒、木材、石材、机械设备等产品），将为广大货主提供在线询价快速报价、在线发货轻松管理、帐单查询一目了然、车辆定位实时追踪等功能。</span>
        </section>
      </div>
    </section>

    <section class="page-part client siji bg" id="siji">
      <div class="page-inner">
        <section class="img-desc">
          <h3 class="page-title">司机端</h3>
          <span class="page-desc">享运司机版APP是一款大宗商品车辆运输接单的APP，将为广大司机提供实时货源快速抢单、路线管理轻松找活、新车购买价格实惠、帐单查询一目了然等功能。</span>
        </section>
        <img src="../assets/images/page_productcenter/siji.png" alt="司机端">
      </div>
    </section>

    <footer-cmp></footer-cmp>

  </div>
</template>

<script type="text/ecmascript-6">
  import HeaderCmp from '@/components/header';
  import FooterCmp from '@/components/footer';

  export default {
    name: 'productcenterPage',
    data() {
      return {

      }
    },
    components: {
      HeaderCmp,
      FooterCmp
    },
    mounted() {
      this.$utils.watchRouteGoAnchor(this);
    },
    // watch: {
    //   '$route' () {
    //     this.$utils.watchRouteGoAnchor(this);
    //   }
    // }
  }

</script>

<style rel="stylesheet/scss" lang="scss">
  @import "../style/_variable";

  .productcenter-page {
    width: 100%; // banner图
    .banner {
      height: 500px;
      &_productcenter {
        background: url("../assets/images/page_productcenter/banner2.png") center no-repeat;
         background-size:100% 100%;
         -moz-background-size:100% 100%;
      }
    }

    .page-part.bg {
      background: $bg-clr;
    }

    .client {
      padding: 122px 0;
      border-bottom: 1px solid $border-clr;
      .img-desc {
          display: inline-block;
          vertical-align: middle;
          width: 638px;
          .page-title {
              font-size: 38px;
              margin-bottom: 24px;
          }
          .page-desc {
              color: $text-clr_light;
              line-height: 2;
          }
      }
      img {
          vertical-align: middle;
          transition: all 1s;
          &:hover {
            transform: scale3d(1.05,1.05,1);
          }
      }

      &.huozhu {
          .img-desc {
            margin-left: 150px;              
          }
      }
      &.siji {
          .img-desc {
              margin-right: 150px;
          }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/productcenter.vue